import { useMemo } from 'react';
import { DbFile, DbFolder, DbTenderFolder } from '~src/types/db';

import { useFolders } from './api-hooks/useFolders';

interface UseItemPermissionParams {
  /** selected file */
  file?: DbFile;
  /** selected folder */
  folder?: DbFolder | DbTenderFolder;
}
/** For a given item (file or folder) return permission of containing folder */
export const useItemPermission = ({
  file,
  folder,
}: UseItemPermissionParams = {}) => {
  const foldersQuery = useFolders(
    {
      as_admin:
        window.sessionStorage.getItem('appState') === 'superUser'
          ? true
          : undefined,
    },
    { enabled: false }
  );

  const itemParentPermission = useMemo(() => {
    let parent: DbFolder | undefined;

    if (file) {
      parent = foldersQuery.data?.find(
        (folder) => folder.id === file.folder_id
      );
    } else if (folder) {
      // for root folders, use folder's permission
      if (folder.parent_id === null) {
        return folder.permission;
      }

      parent = foldersQuery.data?.find(
        (dbFolder) => dbFolder.id === folder.parent_id
      );
    }

    // return parent permission
    return parent ? parent.permission : 0;
  }, [file, folder, foldersQuery.data]);

  return itemParentPermission;
};
